import { Footer } from "../Login/AppStyle";

export default function GeneralFooter ({setToken, myApiClient}) {

    const clearSession = event => {
        // event.preventDefault();
        let HTTPBasic = myApiClient.authentications['HTTPBasic'];
        delete HTTPBasic.username;
        delete HTTPBasic.password;
        setToken('');
        sessionStorage.clear();
        console.log('>>cleared');
    }

    return(
        <Footer>
            <ul type="none">
                <li><a target='_blanc' href='https://www.vcidresden.de'>Kontakt vci</a></li> 
                <li><a target='_blanc' href="https://www.smwa.sachsen.de/">Verlinkung Ministerium</a></li>
                <li>...</li>
                <li>Kontaktformular Support</li>
                {sessionStorage.getItem('token') && <>
                <li>
                    <a href="/" ><button onClick={clearSession}>Ausloggen</button></a>
                </li> </>}
            </ul>
        </Footer>
    )
}

